import React from 'react'
import {BrowserRouter as Router} from "react-router-dom";

function footer() {    
        return (
            <section id="contact" className="section-1 relative">                             
                    <div className="vh-100 slider-h-auto slide-content background-yellow">
                        <div className="col-12 inner">
                         <h2 className="text-white text-center">Contact Me:</h2>                        
                            <div className="">
                                <Router>                        
                                    <p className="text-center text-white"><i className="fa fa-phone-square-alt"></i> 807-631-9096
                                    <br></br>
                                    <i className="fa fa-envelope"></i> estebancreasey@gmail.com
                                    <br></br>                                
                                    </p>                 
                                </Router>   
                            </div>   
                        </div>
                    </div>                                                  
            </section> 
        )    
}
export default footer;